import $ from "jquery";
import Swiper from "swiper";
import { Navigation, A11y, Keyboard, EffectFade } from "swiper/modules";

export const init = function () {
  $(".ctype-ce_image_teaser_tiles").each(function () {
    let $this = $(this);
    let id = $this.find(".swiper-itt-slider").attr("id");
    let ittSlider = {};
    let sliderOptions = {
      modules: [Navigation, A11y, Keyboard, EffectFade],
      effect: "fade",
      navigation: {
        nextEl: ".swiper-itt-slider-next",
        prevEl: ".swiper-itt-slider-prev",
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      fadeEffect: { crossFade: true },
      on: {
        beforeInit: function () {
           $(".ctype-ce_image_teaser_tile .blur-img").parent().fadeOut();
        },
        afterInit: function () {
          $(".ctype-ce_image_teaser_tiles").addClass("slider-init");
        },
      },
    };

    let checkSlider = () => {
      if ($(window).width() < 992) {
        if ("destroyed" in ittSlider || $.isEmptyObject(ittSlider)) {
          $this.find(".swipers").removeClass("swipers").addClass("swiper");
          $this
            .find(".swipers-wrapper")
            .removeClass("swipers-wrapper")
            .addClass("swiper-wrapper");
          ittSlider = new Swiper("#" + id, sliderOptions);
        }
      } else {
        if ("mounted" in ittSlider) {
          $this.find(".swiper").removeClass("swiper").addClass("swipers");
          $this
            .find(".swiper-wrapper")
            .removeClass("swiper-wrapper")
            .addClass("swipers-wrapper");
          ittSlider.destroy();
        }
      }
    };

    $this.find(".swiper").removeClass("swiper").addClass("swipers");
    $this
      .find(".swiper-wrapper")
      .removeClass("swiper-wrapper")
      .addClass("swipers-wrapper");
    checkSlider();

    $(window).on("resize", function () {
      checkSlider();
    });
  });

  $(".ctype-ce_image_teaser_tiles .cover").on("click", (e) => {
    let $box = $(e.target).parents(".box");
    $(".box").removeClass("open");
    $(".text").fadeOut();

    if ($box.hasClass("open")) {
      $box.removeClass("open");
      $box.find(".text").fadeOut();
    } else {
      $box.addClass("open");
      $box.find(".text").fadeIn();
    }
  });

  $(".ctype-ce_image_teaser_tiles .close-btn").on("click", (e) => {
    let $box = $(e.target).parents(".box");

    $box.removeClass("open");
    $box.find(".text").fadeOut();
  });
};
